/* Ink & Mesh — homepage behaviour. Deferred; only on *.ink-mesh templates.
   Config comes from window.InkMesh (snippets/ink-mesh-head.liquid): inks[], once, shader, duotone. */
(function () {
  'use strict';
  var CFG = window.InkMesh || {};
  var INKS = (CFG.inks && CFG.inks.length === 4) ? CFG.inks : ['#FF7A2E', '#8F86FF', '#E3F03A', '#3EDBEB'];
  var root = document.documentElement;
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  root.classList.toggle('im-reduce', reduce);
  // once-per-session motion budget
  try {
    if (CFG.once === true) {
      if (sessionStorage.getItem('im_seen')) root.classList.add('im-revisit'); else sessionStorage.setItem('im_seen', '1');
    }
  } catch (e) {}
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  /* ---------------- hero ---------------- */
  function initHero(hero) {
    if (hero.__im) return; hero.__im = true;
    // headline: random logo ink per line, no repeats per load
    var lines = hero.querySelectorAll('h1 .line');
    if (lines.length) {
      var mode = hero.getAttribute('data-ink-headline') || 'random';
      var C = mode === 'random' ? shuffle(INKS) : INKS;
      lines.forEach(function (l, i) { l.style.setProperty('--lc', mode === 'white' ? '#ffffff' : C[i % C.length]); });
    }
    // 3D tilt
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width * 2 - 1, y = (e.clientY - r.top) / r.height * 2 - 1;
      hero.style.setProperty('--mx', x.toFixed(3)); hero.style.setProperty('--my', (-y).toFixed(3));
    });
    // plates
    var s3d = hero.querySelector('[data-ink-s3d]');
    if (s3d) {
      var plates = [];
      try { plates = JSON.parse(s3d.getAttribute('data-plates') || '[]'); } catch (e) {}
      var cur = s3d.querySelector('.ink-plate__img--duo'), nxt = s3d.querySelector('.ink-plate__img--next'), res = s3d.querySelector('.ink-res');
      var curBg = cur.querySelector('.ink-plate__bg') || cur, nxtBg = nxt.querySelector('.ink-plate__bg') || nxt;
      var curImg = curBg.querySelector('img'), nxtImg = nxtBg.querySelector('img');
      /* plates are uploaded at width=1600; ask the CDN for the size this stage actually shows */
      function sized(url) {
        if (!url || url.indexOf('width=1600') < 0) return url;
        var need = Math.ceil((s3d.getBoundingClientRect().width || 600) * (window.devicePixelRatio || 1));
        var w = need <= 600 ? 600 : need <= 900 ? 900 : need <= 1200 ? 1200 : 1600;
        return url.replace('width=1600', 'width=' + w);
      }
      function base(u) { return String(u || '').replace(/^https?:/, '').replace(/[?&]width=\d+/, ''); }
      function setBg(el, img, url) { url = sized(url); if (img) { if (img.hasAttribute('srcset') && base(img.getAttribute('src')) === base(url)) return; /* first plate already served by srcset + preload */ if (img.hasAttribute('srcset')) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); } if (img.getAttribute('src') !== url) img.src = url; } else { el.style.backgroundImage = 'url(' + url + ')'; } }
      var nameEl = hero.querySelector('[data-ink-stage-name]'), stage = hero.querySelector('[data-ink-stage]');
      var badgeEl = s3d.querySelector('[data-ink-plate-badge]');
      function setBadge(p) { if (!badgeEl) return; var t = (p && p.badge) || ''; badgeEl.textContent = t; badgeEl.hidden = !t; }
      var fadeMode = s3d.getAttribute('data-transition') === 'fade';
      var filterMode = s3d.getAttribute('data-duotone') !== 'prerendered';
      var idx = 0, busy = false, last = 0, hovering = false, loopT = null, inkIdx = 0;
      var T_WIPE = 2600, T_DRY = T_WIPE + 120, T_DONE = T_WIPE + 1900, T_GAP = 900;
      if (fadeMode) { T_DONE = 1300; T_GAP = 2400; }
      function duoUrl(p) { return (fadeMode || filterMode || !p.duo) ? p.col : p.duo; }
      function setDuoMode(p) { if (fadeMode) { cur.classList.remove('is-filter'); return; } cur.classList.toggle('is-filter', filterMode || !p.duo); }
      if (plates.length) { setBg(curBg, curImg, duoUrl(plates[0])); setDuoMode(plates[0]); }
      function pass() {
        if (plates.length < 2 || reduce) return;
        var now = performance.now(); if (busy || now - last < T_DONE + 200 || !hero.classList.contains('in')) return; busy = true; last = now;
        var n = (idx + 1) % plates.length, p = plates[n];
        if (fadeMode) {
          // crossfade: next layer fades in over the current plate, then becomes current
          setBg(nxtBg, nxtImg, p.col);
          void nxt.offsetWidth; s3d.classList.add('fading');
          if (badgeEl) badgeEl.classList.add('is-out');
          setTimeout(function () { if (nameEl) nameEl.textContent = p.name || ''; setBadge(p); if (badgeEl) badgeEl.classList.remove('is-out'); }, 500);
          setTimeout(function () {
            setBg(curBg, curImg, p.col);
            // swap is invisible: cur now holds the same image the fully-faded next layer shows
            cur.style.transition = 'none'; nxt.style.transition = 'none';
            s3d.classList.remove('fading');
            cur.style.opacity = ''; nxt.style.opacity = '';
            void nxt.offsetWidth;
            cur.style.transition = ''; nxt.style.transition = '';
            idx = n; busy = false;
            if (hovering) { clearTimeout(loopT); loopT = setTimeout(pass, T_GAP); }
          }, T_DONE);
          return;
        }
        s3d.style.setProperty('--inkc', INKS[inkIdx % 4]); inkIdx++;
        setBg(nxtBg, nxtImg, p.col); nxt.style.opacity = '';
        if (res) { res.style.webkitMaskImage = 'url(' + p.col + ')'; res.style.maskImage = 'url(' + p.col + ')'; }
        s3d.classList.remove('dry'); void s3d.offsetWidth; s3d.classList.add('wipe');
        setTimeout(function () { if (nameEl) nameEl.textContent = p.name || ''; setBadge(p); }, T_WIPE * 0.5);
        setTimeout(function () { setBg(curBg, curImg, duoUrl(p)); setDuoMode(p); s3d.classList.add('dry'); }, T_DRY);
        setTimeout(function () {
          s3d.classList.remove('wipe'); s3d.classList.remove('dry');
          nxt.style.transition = 'none'; nxt.style.opacity = '0'; void nxt.offsetWidth; nxt.style.transition = ''; nxt.style.opacity = '';
          idx = n; busy = false;
          if (hovering) { clearTimeout(loopT); loopT = setTimeout(pass, T_GAP); }
        }, T_DONE);
      }
      if (stage) {
        stage.addEventListener('mouseenter', function () { hovering = true; pass(); });
        stage.addEventListener('mouseleave', function () { hovering = false; clearTimeout(loopT); });
      }
      var lastY = scrollY;
      addEventListener('scroll', function () { var y = scrollY; if (Math.abs(y - lastY) > 24 && y < innerHeight * 1.2) { lastY = y; pass(); } }, { passive: true });
      // warm the cache once the entrance is over (keeps first paint lean)
      setTimeout(function () { plates.forEach(function (p) { [p.col, p.duo].forEach(function (u) { if (u) { var im = new Image(); im.src = sized(u); } }); }); }, 3200);
    }
    // shader
    var canvas = hero.querySelector('canvas[data-ink-canvas]');
    var lowPower = (window.matchMedia && matchMedia('(pointer:coarse)').matches) || innerWidth < 900 || (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) || (navigator.connection && navigator.connection.saveData);
    if (canvas && CFG.shader !== false && !reduce && !lowPower) setTimeout(function () { initShader(hero, canvas); }, 2400);
    // entrance: wait for the display fonts so the squeegee never catches a glyph swap mid-pass (fallback 900ms)
    var started = hero.classList.contains('in') || hero.__imEntered;   // inline script in the section may have started the entrance already
    function start() {
      if (started) return; started = true;
      hero.classList.add('fonts-ready');
      measurePrints(hero);
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('in'); setTimeout(function () { hero.classList.add('done'); }, 2700); }); });
    }
    if (document.fonts && document.fonts.ready) {
      var fam = getComputedStyle(hero).getPropertyValue('--im-sans').split(',')[0].trim() || 'Work Sans';
      Promise.all([document.fonts.load('800 1em ' + fam), document.fonts.load('700 1em ' + (getComputedStyle(hero).getPropertyValue('--im-cond').split(',')[0].trim() || 'Barlow Condensed'))]).then(start, start);
      document.fonts.ready.then(start, start);
      setTimeout(start, 900);
    } else { setTimeout(start, 150); }
  }

  function initShader(hero, c) {
    var gl = c.getContext('webgl', { antialias: false, alpha: false });
    if (!gl) return;
    var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var fs = 'precision highp float;uniform vec2 R;uniform float T;uniform vec2 M;uniform vec3 C0,C1,C2,C3;' +
      'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}' +
      'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}' +
      'float fbm(vec2 p){float v=0.,a=.5;mat2 m=mat2(1.6,1.2,-1.2,1.6);for(int i=0;i<4;i++){v+=a*n(p);p=m*p;a*=.5;}return v;}' +
      // plastisol: a height-field of slowly folding paste. Surface normal from finite differences
      // gives the wet specular sheen; colour bands stay opaque with darkened creases (thick ink,
      // not watery marble). Accent ink appears as one stirred-in ribbon.
      'float paste(vec2 p,float t,float md){' +
      'vec2 q=vec2(fbm(p+t),fbm(p+vec2(5.2,1.3)-t*.6));' +
      'vec2 r=vec2(fbm(p+4.2*q+vec2(1.7,9.2)+t*.45+md*.4),fbm(p+4.2*q+vec2(8.3,2.8)-t*.3));' +
      'return fbm(p+4.8*r);}' +
      'void main(){vec2 uv=gl_FragCoord.xy/R;vec2 p=uv*vec2(R.x/R.y,1.)*1.05;float t=T*.011;' +
      'vec2 mm=(M-uv)*vec2(R.x/R.y,1.);float md=exp(-dot(mm,mm)*6.);' +
      'float e=.02;float h=paste(p,t,md);' +
      'float hx=paste(p+vec2(e,0.),t,md);float hy=paste(p+vec2(0.,e),t,md);' +
      'vec3 nrm=normalize(vec3(h-hx,h-hy,e*1.6));' +
      'vec3 ink=vec3(0.,.06,.10);vec3 navy=vec3(0.,.26,.39);' +
      'vec3 col=mix(ink,navy,smoothstep(.3,.62,h));' +
      'float sel=fbm(p*.42+vec2(M.x*1.8,M.y*1.5)+t*.25);' +
      'vec3 acc=mix(mix(C0,C1,step(.42,sel)),mix(C2,C3,step(.62,sel)),step(.52,sel));' +
      'float ribbon=smoothstep(.03,.012,abs(sel-.5))*smoothstep(.38,.55,h);' +
      'col=mix(col,acc*.7,ribbon*.8);' +
      'float crease=1.-smoothstep(0.,.22,nrm.z-.55);col*=mix(1.,.68,clamp(crease,0.,1.)*.65);' +
      'vec3 L=normalize(vec3(.35,.55,.75));' +
      'float dif=max(dot(nrm,L),0.);col*=.72+.38*dif;' +
      'vec3 V=vec3(0.,0.,1.);vec3 H=normalize(L+V);' +
      'float spec=pow(max(dot(nrm,H),0.),34.);col+=vec3(.62,.74,.82)*spec*.3;' +
      'float spec2=pow(max(dot(nrm,H),0.),120.);col+=vec3(1.)*spec2*.2;' +
      'col+=acc*md*.25*smoothstep(.4,.8,h);' +
      'float vig=smoothstep(1.35,.35,length((uv-vec2(.62,.5))*vec2(1.2,1.)));col*=mix(.55,1.,vig);' +
      'gl_FragColor=vec4(col,1.);}';
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
    var v = sh(gl.VERTEX_SHADER, vs), f = sh(gl.FRAGMENT_SHADER, fs); if (!v || !f) return;
    var pr = gl.createProgram(); gl.attachShader(pr, v); gl.attachShader(pr, f); gl.linkProgram(pr); gl.useProgram(pr);
    var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var lp = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(lp); gl.vertexAttribPointer(lp, 2, gl.FLOAT, false, 0, 0);
    var uR = gl.getUniformLocation(pr, 'R'), uT = gl.getUniformLocation(pr, 'T'), uM = gl.getUniformLocation(pr, 'M');
    function hex(hx) { var m = /^#?([0-9a-f]{6})$/i.exec(hx); if (!m) return [1, .5, .2]; var n = parseInt(m[1], 16); return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255]; }
    ['C0', 'C1', 'C2', 'C3'].forEach(function (k, i) { var rgb = hex(INKS[i]); gl.uniform3f(gl.getUniformLocation(pr, k), rgb[0] * .95, rgb[1] * .95, rgb[2] * .95); });
    var smx = .6, smy = .5, tmx = .6, tmy = .5, visible = true, raf = 0;
    hero.addEventListener('mousemove', function (e) { var r = c.getBoundingClientRect(); tmx = (e.clientX - r.left) / r.width; tmy = 1 - (e.clientY - r.top) / r.height; });
    function rs() { var d = Math.min(1.25, devicePixelRatio || 1), w = c.clientWidth, h = c.clientHeight, s = .5; c.width = Math.max(1, w * d * s); c.height = Math.max(1, h * d * s); gl.viewport(0, 0, c.width, c.height); }
    rs(); addEventListener('resize', rs);
    var t0 = performance.now();
    var lastT = 0;
    function draw(now) { raf = 0; if (!visible || document.hidden) return; if (now - lastT < 32) { raf = requestAnimationFrame(draw); return; } lastT = now; smx += (tmx - smx) * .06; smy += (tmy - smy) * .06; gl.uniform2f(uR, c.width, c.height); gl.uniform1f(uT, (now - t0) / 1000); gl.uniform2f(uM, smx, smy); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); raf = requestAnimationFrame(draw); }
    function go() { if (!raf) raf = requestAnimationFrame(draw); }
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) go(); }, { threshold: 0 }).observe(hero); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });
    go();
  }

  /* squeegee travel distance = width of the printed text (so blade and reveal stay in lockstep) */
  function measurePrints(scope) {
    (scope || document).querySelectorAll('.print').forEach(function (p) { p.style.setProperty('--pw', Math.round(p.getBoundingClientRect().width) + 'px'); });
  }
  var _rsT; addEventListener('resize', function () { clearTimeout(_rsT); _rsT = setTimeout(function () { measurePrints(document); }, 150); });
  /* ---------------- squeegee prints: one clock for the printed edge and the blade ----------------
     The CSS pairs a clip-path transition/animation on .txt with a separate animation on .msq. Started together they
     still drift apart while the page is busy, and the per-line transition-delay also delays every blade update.
     Here one rAF clock sets --p (0..1) and --mo (blade opacity) on each .print; .print.is-sq CSS reads both.
     Duration/delay/trigger come from the existing CSS: a clip-path transition = waits for an ancestor .in,
     an animation = plays on load. Prints with neither are left alone. Reduced motion keeps the CSS fallbacks. */
  function bezier(x1, y1, x2, y2) {
    function cx(t) { return 3 * x1 * t * (1 - t) * (1 - t) + 3 * x2 * t * t * (1 - t) + t * t * t; }
    function cy(t) { return 3 * y1 * t * (1 - t) * (1 - t) + 3 * y2 * t * t * (1 - t) + t * t * t; }
    return function (x) { if (x <= 0) return 0; if (x >= 1) return 1; var lo = 0, hi = 1, t = x; for (var i = 0; i < 28; i++) { t = (lo + hi) / 2; if (cx(t) < x) lo = t; else hi = t; } return cy(t); };
  }
  var sqEase = bezier(.65, 0, .25, 1), sqItems = [], sqRaf = 0, sqMo = null, SQ_FADE = 600;
  function sqSet(it, p, mo) {
    it.p.style.setProperty('--tw', it.txt.offsetWidth + 'px');
    it.p.style.setProperty('--p', p.toFixed(4));
    it.p.style.setProperty('--mo', mo.toFixed(3));
  }
  function sqTick(it, now) {
    var t = (now - it.t0 - it.dl) / it.dur, mo = 1;
    if (t >= 1) { mo = Math.max(0, 1 - (now - it.t0 - it.dl - it.dur) / SQ_FADE); if (!mo) it.done = true; }
    sqSet(it, sqEase(Math.min(Math.max(t, 0), 1)), mo);
  }
  function sqFrame(now) {
    sqRaf = 0; var live = false;
    sqItems.forEach(function (it) {
      if (it.done || it.t0 == null) return;
      sqTick(it, now);
      if (!it.done) live = true;
    });
    if (live) sqRaf = requestAnimationFrame(sqFrame);
  }
  function sqCheck() {
    var now = performance.now(), go = false;
    sqItems.forEach(function (it) { if (!it.done && it.t0 == null && it.p.closest('.in')) { it.t0 = now; go = true; } });
    if (go && !sqRaf) sqRaf = requestAnimationFrame(sqFrame);
  }
  function initSqueegee(scope) {
    if (reduce) return;
    (scope || document).querySelectorAll('.print').forEach(function (p) {
      var txt = p.querySelector('.txt'), msq = p.querySelector('.msq');
      if (!txt || !msq || p.__sq) return;
      var cs = getComputedStyle(txt), mode = null, dur = 0, dl = 0;
      if (/clip-path|all/.test(cs.transitionProperty) && parseFloat(cs.transitionDuration) > 0) { mode = 'in'; dur = parseFloat(cs.transitionDuration); dl = parseFloat(cs.transitionDelay) || 0; }
      else if (cs.animationName && cs.animationName !== 'none' && parseFloat(cs.animationDuration) > 0) { mode = 'load'; dur = parseFloat(cs.animationDuration); dl = parseFloat(cs.animationDelay) || 0; }
      if (!mode) return;
      var it = { p: p, txt: txt, dur: dur * 1000, dl: dl * 1000, t0: null, done: false };
      var run = txt.getAnimations ? txt.getAnimations()[0] : null; // already in flight: continue from where CSS got to
      if (run && run.currentTime != null) it.t0 = performance.now() - run.currentTime;
      else if (mode === 'load') it.t0 = performance.now();
      else if (p.closest('.in')) it.done = true; // finished before this ran
      p.__sq = it;
      if (it.done) sqSet(it, 1, 0);
      else if (it.t0 != null) sqTick(it, performance.now()); // current moment, set before the CSS hand-off
      else sqSet(it, 0, 0);
      p.classList.add('is-sq');
      sqItems.push(it);
    });
    if (!sqMo && 'MutationObserver' in window) {
      sqMo = new MutationObserver(function () { if (sqItems.some(function (it) { return !it.done && it.t0 == null; })) sqCheck(); });
      sqMo.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    sqCheck();
    if (!sqRaf && sqItems.some(function (it) { return !it.done && it.t0 != null; })) sqRaf = requestAnimationFrame(sqFrame);
  }
  /* ---------------- lazy backgrounds: [data-bg] loads when near the viewport; data-bg-lazy="hover" loads on first hover/touch or shortly after its card is on screen ---------------- */
  function applyBg(el) { if (el.__bg) return; el.__bg = true; el.style.backgroundImage = 'url(' + el.getAttribute('data-bg') + ')'; }
  function initLazyBg(scope) {
    var els = [].slice.call((scope || document).querySelectorAll('[data-bg]'));
    if (!('IntersectionObserver' in window)) { els.forEach(applyBg); return; }
    var near = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { applyBg(e.target); near.unobserve(e.target); } }); }, { rootMargin: '500px 0px' });
    els.forEach(function (el) {
      if (el.getAttribute('data-bg-lazy') === 'hover') {
        var host = el.closest('.pc, .pr') || el; var once = function () { applyBg(el); };
        host.addEventListener('mouseenter', once, { once: true }); host.addEventListener('touchstart', once, { once: true, passive: true });
        var io2 = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io2.disconnect(); setTimeout(once, 1500); } }, { rootMargin: '0px' }); io2.observe(host);
      } else near.observe(el);
    });
  }
  /* ---------------- generic reveal (print-in on scroll) ---------------- */
  function initReveal(el) {
    if (el.__imR) return; el.__imR = true;
    var th = parseFloat(el.getAttribute('data-threshold') || '.2');
    if (!('IntersectionObserver' in window) || reduce) { el.classList.add('in'); el.classList.add('done'); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { measurePrints(el); el.classList.add('in'); setTimeout(function () { el.classList.add('done'); }, 2200); io.disconnect(); } }); }, { threshold: th });
    io.observe(el);
  }
  /* ---------------- category cards: per-card print-in, 3D tilt, squeegee back on leave ---------------- */
  function initCats(sec) {
    if (sec.__imC) return; sec.__imC = true;
    var cards = [].slice.call(sec.querySelectorAll('[data-ink-card]'));
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .18 });
      cards.forEach(function (c) { io.observe(c); });
    } else { cards.forEach(function (c) { c.classList.add('in'); }); }
    cards.forEach(function (c) {
      c.addEventListener('mousemove', function (e) { var r = c.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width * 2 - 1, y = (e.clientY - r.top) / r.height * 2 - 1; c.style.setProperty('--mx', x.toFixed(3)); c.style.setProperty('--my', (-y).toFixed(3)); });
      c.addEventListener('mouseleave', function () { c.style.setProperty('--mx', 0); c.style.setProperty('--my', 0); c.classList.add('leaving'); clearTimeout(c._lt); c._lt = setTimeout(function () { c.classList.remove('leaving'); }, 1950); });
      c.addEventListener('mouseenter', function () { c.classList.remove('leaving'); clearTimeout(c._lt); });
      // touch: quick tap navigates (native), tap-and-hold runs the squeegee, release re-inks
      var lpT = null, lpOn = false, sx = 0, sy = 0, blockClick = false;
      c.addEventListener('touchstart', function (e) {
        document.documentElement.classList.add('im-touch');
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; lpOn = false;
        clearTimeout(lpT);
        lpT = setTimeout(function () { lpOn = true; c.classList.remove('leaving'); clearTimeout(c._lt); c.classList.add('touch-print'); }, 320);
      }, { passive: true });
      c.addEventListener('touchmove', function (e) {
        if (lpOn) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) clearTimeout(lpT); // scrolling, not holding
      }, { passive: true });
      function endTouch() {
        clearTimeout(lpT);
        if (!lpOn) return;
        blockClick = true;
        c.classList.remove('touch-print'); c.classList.add('leaving');
        clearTimeout(c._lt); c._lt = setTimeout(function () { c.classList.remove('leaving'); }, 1950);
        setTimeout(function () { blockClick = false; lpOn = false; }, 700);
      }
      c.addEventListener('touchend', endTouch);
      c.addEventListener('touchcancel', endTouch);
      c.addEventListener('click', function (e) { if (blockClick) { e.preventDefault(); e.stopPropagation(); } });
      c.addEventListener('contextmenu', function (e) { if (lpOn || c.classList.contains('touch-print')) e.preventDefault(); });
    });
  }
  /* ---------------- brands: fly-in vectors + reveal ---------------- */
  function initBrands(b) {
    if (b.__imB) return; b.__imB = true;
    var throwD = parseFloat(getComputedStyle(b.closest('.ink-section') || b).getPropertyValue('--im-throw')) || 900;
    var fly = b.getAttribute('data-flyin') !== 'false';
    var names = [].slice.call(b.querySelectorAll('.mq__t span'));
    names.forEach(function (n, i) {
      if (!fly || reduce) { n.style.setProperty('--fx', '0px'); n.style.setProperty('--fy', '0px'); n.style.setProperty('--fr', '0deg'); n.style.setProperty('--fd', '0s'); return; }
      // fly-in from scattered directions — bounded throw so logos stay near their slot while airborne
      var ang = Math.random() * Math.PI * 2, dist = throwD * .18 + Math.random() * throwD * .3;
      n.style.setProperty('--fx', (Math.cos(ang) * dist).toFixed(0) + 'px'); n.style.setProperty('--fy', (Math.sin(ang) * dist * .7).toFixed(0) + 'px');
      n.style.setProperty('--fr', ((Math.random() - .5) * 160).toFixed(1) + 'deg'); n.style.setProperty('--fd', (Math.random() * .35 + (i % 11) * .05).toFixed(2) + 's');
    });
    // reveal settles the fly-in; the marquee only starts rolling once every logo has decoded
    // (an undecoded img with width:auto has no width yet — starting early scrolls a half-laid-out belt)
    function reveal() {
      if (b.__rev) return; b.__rev = true; b.classList.add('in');
      var imgs = [].slice.call(b.querySelectorAll('.mq__t img'));
      var ready = Promise.all(imgs.map(function (im) { return (im.decode ? im.decode() : Promise.resolve()).catch(function () { }); }));
      var cap = new Promise(function (r) { setTimeout(r, 2500); });
      Promise.race([ready, cap]).then(function () {
        setTimeout(function () { b.classList.add('rolling'); }, (fly && !reduce) ? 1800 : 0);
      });
    }
    if (!('IntersectionObserver' in window) || reduce) { reveal(); return; }
    var done = false;
    function fire() { if (done) return; done = true; reveal(); io.disconnect(); window.removeEventListener('scroll', onScroll); }
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) fire(); }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    io.observe(b);
    function inView() { var r = b.getBoundingClientRect(); return r.top < innerHeight * 0.92 && r.bottom > 0; }
    function onScroll() { if (inView()) fire(); }
    if (inView()) fire();
    else { window.addEventListener('scroll', onScroll, { passive: true }); }
    // Failsafe: never leave the marquee blank if the observer misses.
    setTimeout(function () { fire(); }, 3000);
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measurePrints(document); });
  /* ---------------- pinned story: scroll progress drives the passes ---------------- */
  function initStory(sec) {
    if (sec.__imS) return; sec.__imS = true;
    var wrap = sec.querySelector('[data-story-wrap]'), vis = sec.querySelector('[data-story-vis]');
    if (!wrap || !vis) return;
    var sts = [].slice.call(vis.querySelectorAll('.st')), sq = sec.querySelector('[data-story-sq]'), film = sec.querySelector('[data-story-film]');
    var chaps = [].slice.call(sec.querySelectorAll('.chap')), rail = [].slice.call(sec.querySelectorAll('[data-story-rail] li'));
    var N = sts.length, sl = 0, lastCur = -1, ticking = false;
    if (reduce) { wrap.style.height = 'auto'; sts.forEach(function (s, i) { s.style.position = 'relative'; s.style.clipPath = 'none'; s.style.visibility = i === 0 ? 'visible' : 'hidden'; }); return; }
    function poly(a, b) { return 'polygon(calc(' + a + '% + ' + sl + 'px) -10%,calc(' + b + '% + ' + sl + 'px) -10%,calc(' + b + '% - ' + sl + 'px) 110%,calc(' + a + '% - ' + sl + 'px) 110%)'; }
    function update() {
      ticking = false;
      var r = wrap.getBoundingClientRect(), vh = innerHeight, total = r.height - vh; if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / total));
      sl = vis.clientHeight * .78 * .0525;
      var seg = Math.min(N - 1, Math.floor(p * N)), t = p * N - seg, passT = (seg < N - 1) ? Math.min(1, Math.max(0, (t - .68) / .32)) : 0;
      var rev = []; for (var k = 0; k < N; k++) rev[k] = k <= seg ? 100 : (k === seg + 1 ? passT * 100 : 0);
      for (k = 0; k < N; k++) {
        var a = (k + 1 < N) ? rev[k + 1] : 0, b = rev[k], st = sts[k];
        if (b <= 0) { st.style.clipPath = 'inset(0 100% 0 0)'; st.style.visibility = 'hidden'; }
        else { st.style.visibility = 'visible'; st.style.clipPath = (a >= 100) ? 'inset(0 100% 0 0)' : poly(a, b); }
        st.classList.toggle('cur', k === seg && passT < 1); st.classList.toggle('done', k < seg);
      }
      if (passT > 0 && passT < 1) { sq.style.opacity = 1; sq.style.left = 'calc(' + (passT * 100) + '% - 19px)'; film.style.opacity = (.34 * (1 - passT)).toFixed(3); film.style.clipPath = poly(0, passT * 100); }
      else { sq.style.opacity = 0; film.style.opacity = 0; }
      var cur = (passT > .5) ? seg + 1 : seg;
      if (cur !== lastCur) { lastCur = cur; chaps.forEach(function (c, i) { c.classList.toggle('on', i === cur); }); rail.forEach(function (l, i) { l.classList.toggle('on', i === cur); l.classList.toggle('done', i < cur); }); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', update); update();
    var c = sec.querySelector('canvas[data-story-map]');
    if (c) { var loadMap = function () { fetch(sec.getAttribute('data-dots')).then(function (r) { return r.json(); }).then(function (data) { initMap(sec, c, data); }).catch(function () {}); };
      if ('IntersectionObserver' in window) { var mio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { mio.disconnect(); loadMap(); } }, { rootMargin: '600px 0px' }); mio.observe(sec); } else loadMap(); }
  }
  function initMap(sec, c, data) {
    var ctx = c.getContext('2d'), DOTS = data.dots, CITIES = data.cities, WH = data.warehouses;
    var ACC = sec.getAttribute('data-accent') || '#EA0707';
    var minx = -124.8, maxx = -66.9, miny = 24.4, maxy = 49.4, k = Math.cos(37 * Math.PI / 180), W, H, scale, ox, oy, dpr = Math.min(2, devicePixelRatio || 1);
    function proj(lon, lat) { return [ox + (lon - minx) * k * scale, oy + (maxy - lat) * scale]; }
    function size() { var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); var mapW = (maxx - minx) * k, mapH = (maxy - miny); scale = Math.min((W * .96) / mapW, (H * .86) / mapH); ox = (W - mapW * scale) / 2; oy = (H - mapH * scale) / 2 - H * .03; }
    size(); addEventListener('resize', size);
    var arcs = CITIES.map(function (ci, i) { var d0 = Math.hypot(ci[0] - WH[0].lon, ci[1] - WH[0].lat), d1 = Math.hypot(ci[0] - WH[1].lon, ci[1] - WH[1].lat); var w = d0 < d1 ? WH[0] : WH[1]; return { from: [w.lon, w.lat], to: ci, t0: i * .55 + ((i * 7) % 10) / 25, dur: 2.6 + ((i * 3) % 10) / 12 }; });
    var start = performance.now(), visible = false, raf = 0;
    function qpt(a, b, ctl, t) { var mt = 1 - t; return [mt * mt * a[0] + 2 * mt * t * ctl[0] + t * t * b[0], mt * mt * a[1] + 2 * mt * t * ctl[1] + t * t * b[1]]; }
    function frame(now) {
      raf = 0; var T = (now - start) / 1000; ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(156,199,224,.45)'; for (var i = 0; i < DOTS.length; i++) { var pt = proj(DOTS[i][0], DOTS[i][1]); ctx.beginPath(); ctx.arc(pt[0], pt[1], 1.7, 0, 6.283); ctx.fill(); }
      var loop = arcs.length * .55 + 4;
      arcs.forEach(function (a) { var lt = (T - a.t0) % loop; if (lt < 0 || lt > a.dur + 1.2) return; var t = Math.min(1, lt / a.dur);
        var A = proj(a.from[0], a.from[1]), B = proj(a.to[0], a.to[1]); var mx = (A[0] + B[0]) / 2, my = (A[1] + B[1]) / 2, dx = B[0] - A[0], dy = B[1] - A[1], len = Math.hypot(dx, dy); var ctl = [mx - dy * .28, my + dx * .28 - len * .12];
        var e = 1 - Math.pow(1 - t, 3); ctx.beginPath(); var n = Math.max(2, Math.floor(40 * e)); for (var jj = 0; jj <= n; jj++) { var q = qpt(A, B, ctl, e * jj / n); if (jj === 0) ctx.moveTo(q[0], q[1]); else ctx.lineTo(q[0], q[1]); }
        var fade = lt > a.dur ? 1 - (lt - a.dur) / 1.2 : 1; ctx.strokeStyle = 'rgba(255,107,107,' + (.75 * fade) + ')'; ctx.lineWidth = 1.6; ctx.stroke();
        var hp = qpt(A, B, ctl, e); if (t < 1) { ctx.beginPath(); ctx.arc(hp[0], hp[1], 3, 0, 6.283); ctx.fillStyle = '#fff'; ctx.fill(); }
        if (t >= 1) { var rr = 4 + (lt - a.dur) * 14; ctx.beginPath(); ctx.arc(B[0], B[1], rr, 0, 6.283); ctx.strokeStyle = 'rgba(255,155,155,' + (.7 * fade) + ')'; ctx.lineWidth = 1.5; ctx.stroke(); }
        ctx.beginPath(); ctx.arc(B[0], B[1], 2.4, 0, 6.283); ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.fill(); });
      WH.forEach(function (w, i) { var pt = proj(w.lon, w.lat); var pulse = (T * .9 + i * .5) % 1; ctx.beginPath(); ctx.arc(pt[0], pt[1], 6 + pulse * 22, 0, 6.283); ctx.strokeStyle = 'rgba(234,7,7,' + (.55 * (1 - pulse)) + ')'; ctx.lineWidth = 2; ctx.stroke();
        ctx.beginPath(); ctx.arc(pt[0], pt[1], 6, 0, 6.283); ctx.fillStyle = ACC; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = '#fff'; ctx.stroke();
        ctx.font = '700 12px "Barlow Condensed",Arial Narrow,sans-serif'; ctx.fillStyle = '#fff'; ctx.textAlign = 'left'; ctx.fillText(w.n.toUpperCase(), pt[0] + 11, pt[1] + 4); });
      if (visible && !document.hidden && !reduce) raf = requestAnimationFrame(frame);
    }
    function go() { if (!raf) raf = requestAnimationFrame(frame); }
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) go(); }, { threshold: 0 }).observe(c); } else { visible = true; go(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) go(); });
    if (reduce) frame(start + 2000);
  }
  /* ---------------- staples: AJAX add (falls back to a normal POST) ---------------- */
  // Post-add toast with the free-shipping gap (threshold mirrors the shipping
  // function's $300 supplies rule; freight-excluded items can't be detected
  // client-side, hence the "supply orders" phrasing).
  var FREESHIP = 30000;
  var toastTimer = null;
  function addToast() {
    if (document.querySelector('.ink-cart')) return; // cart page has the live bar
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var el = document.querySelector('.ink-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'ink-toast';
        document.body.appendChild(el);
      }
      var rem = FREESHIP - c.total_price;
      var msg = rem > 0
        ? 'Added to cart — <b>$' + (rem / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</b> to free shipping on supply orders'
        : 'Added to cart — this supply order ships free';
      el.innerHTML = '<span class="ink-toast__ok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg></span><span>' + msg + '</span><a href="/cart">View cart</a>';
      requestAnimationFrame(function () { el.classList.add('on'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.classList.remove('on'); }, 4600);
    }).catch(function () {});
  }

  function initAdd(form) {
    if (form.__imA) return; form.__imA = true;
    var qin = form.querySelector('[name=quantity]');
    // step/min come from the input attrs — increment-5 products render step=5 min=5
    var step = parseInt(qin && qin.getAttribute('step'), 10) || 1;
    var min = parseInt(qin && qin.getAttribute('min'), 10) || step;
    [].forEach.call(form.querySelectorAll('[data-ink-qty]'), function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qin.value, 10) || min;
        v += (b.getAttribute('data-ink-qty') === '+') ? step : -step;
        if (v < min) v = min;
        qin.value = v;
      });
    });
    if (qin && qin.type !== 'hidden') {
      qin.addEventListener('change', function () {
        var v = parseInt(qin.value, 10) || min;
        v = Math.max(min, Math.ceil(v / step) * step);
        qin.value = v;
      });
    }
    form.addEventListener('submit', function (e) {
      // An app validating its own fields (Globo required options) cancels the submit first: respect it.
      if (!window.fetch || e.defaultPrevented) return; e.preventDefault();
      var btn = form.querySelector('button[type=submit]'); var old = btn.innerHTML; btn.disabled = true; btn.textContent = '...';
      var qty = parseInt(qin && qin.value, 10) || 1;
      // Line-item properties ride along like a normal form post: Globo Product Options keeps its answers in
      // hidden properties[...] inputs inside this form (e.g. the PMS code on custom inks). Empty values and
      // Globo's empty {} / [] bookkeeping fields are left out, as the old theme's add did.
      var add = { id: form.querySelector('[name=id]').value, quantity: qty }, props = {}, np = 0;
      [].forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        var v = el.value; if (v === '' || v === '{}' || v === '[]') return;
        props[el.name.slice(11, -1)] = v; np++;
      });
      if (np) add.properties = props;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(add) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { btn.textContent = 'Added'; document.dispatchEvent(new CustomEvent('ink:cart:added')); addToast(); setTimeout(function () { btn.innerHTML = old; btn.disabled = false; }, 1800); })
        .catch(function () { btn.innerHTML = old; btn.disabled = false; form.submit(); });
    });
  }

  /* ---------------- reviews carousel ---------------- */
  function initCarousel(t) {
    if (t.__imK) return; t.__imK = true;
    var sec = t.closest('.revs') || t.parentNode, cards = [].slice.call(t.children), dots = sec.querySelector('[data-ink-rdots]'), prev = sec.querySelector('[data-ink-rprev]'), next = sec.querySelector('[data-ink-rnext]');
    if (!cards.length) return;
    function per() { return innerWidth > 900 ? 3 : 1; } function pages() { return Math.max(1, Math.ceil(cards.length / per())); }
    function step() { return (cards[0].getBoundingClientRect().width + 16) * per(); }
    function page() { return Math.round(t.scrollLeft / step()); }
    function paint() { if (!dots) return; var n = pages(), cur = Math.min(n - 1, page()); dots.innerHTML = ''; for (var i = 0; i < n; i++) { var d = document.createElement('i'); if (i === cur) d.className = 'on'; d.setAttribute('data-i', i); d.addEventListener('click', function () { go(+this.getAttribute('data-i')); }); dots.appendChild(d); } }
    function go(i) { var n = pages(); i = ((i % n) + n) % n; t.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(page() - 1); }); if (next) next.addEventListener('click', function () { go(page() + 1); });
    t.addEventListener('scroll', function () { clearTimeout(t._pt); t._pt = setTimeout(paint, 80); }, { passive: true }); addEventListener('resize', paint); paint();
    var iv = parseInt(t.getAttribute('data-autoplay') || '0', 10), timer = null, wrap = t.parentNode;
    function start() { stop(); if (iv > 0 && !reduce) timer = setInterval(function () { if (!document.hidden) go(page() + 1); }, iv); } function stop() { clearInterval(timer); }
    wrap.addEventListener('mouseenter', stop); wrap.addEventListener('mouseleave', start); wrap.addEventListener('focusin', stop); wrap.addEventListener('focusout', start);
    start();
  }
  /* ---------------- learning tabs ---------------- */
  function initTabs(L) {
    if (L.__imT) return; L.__imT = true;
    var tabs = [].slice.call(L.querySelectorAll('.tab')), panels = [].slice.call(L.querySelectorAll('.tabp')), mores = [].slice.call(L.querySelectorAll('.learn__foot .more'));
    tabs.forEach(function (t) { t.addEventListener('click', function () { var k = t.getAttribute('data-t');
      tabs.forEach(function (x) { var on = x === t; x.classList.toggle('on', on); x.setAttribute('aria-selected', on); });
      panels.forEach(function (p) { var on = p.getAttribute('data-p') === k; p.classList.toggle('on', on); if (on) { p.querySelectorAll('.ac').forEach(function (a) { a.style.transition = 'none'; a.style.setProperty('--rev', '-12%'); void a.offsetWidth; a.style.transition = ''; a.style.removeProperty('--rev'); }); } });
      mores.forEach(function (m) { m.hidden = m.getAttribute('data-for') !== k; });
    }); });
  }

  /* ---------------- header: solid on scroll, announcement bar slides away, mobile drawer ---------------- */
  function initHeader(h) {
    if (h.__imH) return; h.__imH = true;
    var nav = h.querySelector('[data-ink-nav]'), ann = h.querySelector('[data-ink-ann]'), b = h.querySelector('[data-ink-burger]'), m = h.querySelector('[data-ink-mmenu]'), x = h.querySelector('[data-ink-mclose]');
    function onS() { var s = scrollY > 40; nav.classList.toggle('solid', s); if (ann) ann.classList.toggle('hide', s); }
    addEventListener('scroll', onS, { passive: true }); onS();
    // announcement bar: hide whole trailing promos until everything fits — text is never clipped mid-word
    var annWrap = ann && ann.querySelector('.wrap');
    function fitAnn() {
      if (!annWrap) return;
      var ps = [].slice.call(annWrap.children).filter(function (x) { return x.tagName === 'SPAN' && !x.classList.contains('ann__tel'); });
      ps.forEach(function (p) { p.style.display = ''; });
      for (var i = ps.length - 1; i > 0; i--) {
        if (annWrap.scrollWidth <= annWrap.clientWidth + 1) break;
        ps[i].style.display = 'none';
      }
    }
    fitAnn();
    addEventListener('resize', function () { clearTimeout(h.__imFA); h.__imFA = setTimeout(fitAnn, 120); });
    // phones/tablets: the Search control in the bar opens the full-width field under it (focus inside the tap so the keyboard opens)
    var sb = h.querySelector('[data-ink-sbtn]'), ms = h.querySelector('[data-ink-msearch]');
    function setSearch(o) {
      if (!sb || !ms) return;
      nav.classList.toggle('nav--sopen', o); sb.setAttribute('aria-expanded', o);
      if (o) { var si = ms.querySelector('input[type="search"]'); if (si) si.focus(); }
    }
    if (sb && ms) {
      sb.addEventListener('click', function () { setSearch(!nav.classList.contains('nav--sopen')); });
      document.addEventListener('click', function (e) { if (nav.classList.contains('nav--sopen') && !nav.contains(e.target)) setSearch(false); });
    }
    function setOpen(o) { if (o) setSearch(false); m.classList.toggle('open', o); b.setAttribute('aria-expanded', o); document.documentElement.style.overflow = o ? 'hidden' : ''; }
    if (b && m) { b.addEventListener('click', function () { setOpen(!m.classList.contains('open')); }); }
    if (x) x.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (m && m.classList.contains('open')) setOpen(false);
      else if (nav.classList.contains('nav--sopen')) { setSearch(false); sb.focus(); }
    });
    document.addEventListener('ink:cart:added', function () { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { var a = h.querySelector('.nav__icons a[href*="/cart"]'); if (!a) return; var n = a.querySelector('[data-ink-cart-count]'); if (!n) { n = document.createElement('span'); n.className = 'count'; n.setAttribute('data-ink-cart-count', ''); a.appendChild(n); } var qty = (c.items || []).reduce(function (s, it) { return String(it.product_type || '').indexOf('mws_fee_generated') === 0 ? s : s + it.quantity; }, 0); n.textContent = qty; n.hidden = qty === 0; }).catch(function () {}); }); /* Upcharge Fees lines are left out of the badge */
    initPredictive(h);
  }

  /* ---------------- predictive search: suggest-as-you-type dropdown (desktop nav + mobile drawer) ---------------- */
  function initPredictive(h) {
    function esc(t) { var d = document.createElement('span'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function thumb(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
    [].forEach.call(h.querySelectorAll('form[role="search"]'), function (form) {
      if (form.__imPS) return; form.__imPS = true;
      var input = form.querySelector('input[type="search"]'); if (!input) return;
      var panel = document.createElement('div'); panel.className = 'psr'; panel.setAttribute('role', 'listbox');
      form.style.position = 'relative'; form.appendChild(panel);
      var t = null, ctrl = null, lastQ = '', lastProds = [];
      /* UPDATES §38 parity: suggest.json strips SKUs, so hydrate a "SKU ..." line from the CDN-cached /products/{handle}.js;
         a SKU-shaped query (no spaces, 4+ chars) with exactly one product match jumps straight to it on Enter. */
      var skuCache = {};
      function skuFor(handle, q) {
        if (!skuCache[handle]) skuCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        return skuCache[handle].then(function (p) {
          if (!p || !p.variants) return '';
          var ql = q.toLowerCase(), hit = null;
          p.variants.forEach(function (v) { if (!hit && v.sku && v.sku.toLowerCase().indexOf(ql) > -1) hit = v.sku; });
          return hit || (p.variants[0] && p.variants[0].sku) || '';
        });
      }
      function skuShaped(q) { return q.length >= 4 && !/\s/.test(q); }
      /* Precision pass (2026-10-27, same rule as the search page): Shopify suggests loose matches ("hoop tech" ->
         Tech Weave backing), so rank by search words that start a word in the title, vendor, type or tags: all words
         in the title, all words anywhere, then some words; drop products matching none. Part-number queries skip
         this (suggest.json has no SKUs to check). */
      var STOPW = ' for and the with of a an to in on or by ';
      function normS(t) { return ' ' + String(t == null ? '' : t).toLowerCase().replace(/[-_\/,()"'#:;|+&]/g, ' ').replace(/\s+/g, ' ') + ' '; }
      function stemW(w) { return w.length > 4 && /(sh|x)es$/.test(w) ? w.slice(0, -2) : (w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w); }
      function rankProds(prods, q) {
        if (/\d/.test(q) && !/\s/.test(q.trim())) return prods.slice(0, 6);
        var words = normS(q).trim().split(' ').filter(function (w) { return w && STOPW.indexOf(' ' + w + ' ') < 0; });
        var terms = words.map(stemW);
        var keep = prods.map(function (p, i) {
          var tt = normS(p.title), hay = tt + normS([p.vendor, p.type, (p.tags || []).join(' ')].join(' '));
          var hits = terms.filter(function (t) { return hay.indexOf(' ' + t) > -1; }).length;
          // a typed plural must be in the title as typed ("needles" is not "18-Needle")
          var inT = hits === terms.length && terms.every(function (t, k) { return tt.indexOf(' ' + (t !== words[k] ? words[k] : t)) > -1; });
          return { p: p, i: i, s: hits === terms.length ? (inT ? 3 : 2) : (hits ? 1 : 0) };
        }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });
        return keep.length ? keep.slice(0, 6).map(function (x) { return x.p; }) : prods.slice(0, 4);
      }
      function close() { panel.classList.remove('open'); panel.innerHTML = ''; }
      function render(d, q) {
        var res = (d.resources && d.resources.results) || {};
        var prods = rankProds(res.products || [], q), queries = res.queries || [];
        var others = (res.pages || []).concat(res.articles || []).slice(0, 4);
        if (!prods.length && !queries.length && !others.length) { close(); return; }
        var html = '';
        if (queries.length) {
          html += '<div class="psr__qs">' + queries.slice(0, 4).map(function (s) {
            // styled_text arrives from Shopify with <mark> highlighting only — safe to inject
            return '<a class="psr__q" href="/search?q=' + encodeURIComponent(s.text) + '">' + s.styled_text + '</a>';
          }).join('') + '</div>';
        }
        html += prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + thumb(p.featured_image.url) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="psr__ph"></span>';
          return '<a class="psr__row" href="' + p.url + '">' + img + '<span class="psr__t">' + esc(p.title) + '<small class="psr__sku" data-h="' + esc(p.handle) + '"></small></span>' + (p.price && +p.price > 0 && (p.tags || []).indexOf('quote-only') < 0 ? '<b>$' + esc(p.price) + '</b>' : '') + '</a>';
        }).join('');
        if (others.length) {
          html += '<div class="psr__k">Guides &amp; pages</div>' + others.slice(0, 4).map(function (o) {
            return '<a class="psr__pg" href="' + o.url + '">' + esc(o.title) + '</a>';
          }).join('');
        }
        html += '<a class="psr__all" href="/search?q=' + encodeURIComponent(q) + '">All results for “' + esc(q) + '” →</a>';
        panel.innerHTML = html; panel.classList.add('open');
        lastProds = prods;
        [].forEach.call(panel.querySelectorAll('.psr__sku[data-h]'), function (el) {
          skuFor(el.getAttribute('data-h'), q).then(function (sku) { if (sku && el.isConnected) el.textContent = 'SKU ' + sku; });
        });
      }
      function go() {
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        if (q === lastQ && panel.classList.contains('open')) return;
        lastQ = q;
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query,page,article&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][prefix]=last', { signal: ctrl && ctrl.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (d) { if (input.value.trim() === q) render(d, q); })
          .catch(function () {});
      }
      input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(go, 220); });
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2) go(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
        if (e.key === 'Enter') {
          var q = input.value.trim();
          if (skuShaped(q) && q === lastQ && lastProds.length === 1) { e.preventDefault(); location.href = lastProds[0].url; }
        }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* ---------------- Booster "Also Bought" enhancer: splice real SKU/stock/buy rows into app tiles ----------------
     Each tile's product fragment is server-rendered by sections/ink-tile-fragment.liquid via the
     Section Rendering API, so badges and buy rules are byte-identical to the catalog tiles. */
  function initBoosterEnhance() {
    if (!document.querySelector('.ink-product, .ink-cart')) return;
    if (document.__imBE) return; document.__imBE = true;
    var frags = {}; // handle -> Promise<html>
    function fragFor(handle) {
      if (!frags[handle]) {
        frags[handle] = fetch('/products/' + handle + '?section_id=ink-tile-fragment', { headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw 0; return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var f = doc.querySelector('[data-ink-frag]');
            return f ? f.outerHTML : '';
          }).catch(function () { return ''; });
      }
      return frags[handle];
    }
    function enhance(tile) {
      if (tile.__imE) return; tile.__imE = true;
      var link = tile.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      fragFor(m[1]).then(function (html) {
        if (!html || tile.querySelector('[data-ink-frag]')) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var frag = holder.firstElementChild;
        // quote-only (tagged or $0): swap the app's own price for "Price on request", same as the catalog tiles
        if (frag.hasAttribute('data-ink-quote')) [].forEach.call(tile.querySelectorAll('.cbb-also-bought-product-price-container'), function (pc) { pc.innerHTML = '<span class="tile__price tile__price--quote">Price on request</span>'; });
        // otherwise swap the app's retail "$80.00 USD" for the store-format price in the shopper's context (B2B / WPD)
        var fp = frag.querySelector('[data-ink-frag-price]');
        if (fp) { fp.parentNode.removeChild(fp); fp.hidden = false; [].forEach.call(tile.querySelectorAll('.cbb-also-bought-product-price-container'), function (pc) { pc.innerHTML = ''; pc.appendChild(fp.cloneNode(true)); }); }
        tile.appendChild(frag);
        [].forEach.call(tile.querySelectorAll('form[data-ink-add]'), initAdd);
      });
    }
    function sweep() {
      [].forEach.call(document.querySelectorAll('.cbb-also-bought-product'), enhance);
      // Quoter (installed, unused on Ink) injects "Get a quote" into the first add-to-cart form it finds - on a quote-only
      // product page that's an Also Bought tile for a different product. Its inline styles beat CSS, so remove the node.
      [].forEach.call(document.querySelectorAll('[id^="get-a-quote-cfp-button"]'), function (b) { b.remove(); });
    }
    sweep();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { sweep(); }).observe(document.body, { childList: true, subtree: true });
    } else { setTimeout(sweep, 2500); setTimeout(sweep, 6000); }
  }


  /* ---------------- click-to-load YouTube embeds ([data-ink-yt]) ---------------- */
  function initYt(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ink-yt]'), function (v) {
      if (v.__imY) return; v.__imY = true;
      var btn = v.querySelector('.bvid__poster'); if (!btn) return;
      btn.addEventListener('click', function () {
        var id = v.getAttribute('data-ink-yt');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.className = 'bvid__frame';
        btn.replaceWith(f);
      });
    });
  }
  function boot(scope) {
    var r = scope || document;
    r.querySelectorAll('[data-ink-header]').forEach(initHeader);
    initLazyBg(r);
    r.querySelectorAll('[data-ink-rtrack]').forEach(initCarousel);
    r.querySelectorAll('[data-ink-tabs]').forEach(initTabs);
    r.querySelectorAll('[data-ink-story]').forEach(initStory);
    r.querySelectorAll('form[data-ink-add]').forEach(initAdd);
    r.querySelectorAll('[data-ink-hero]').forEach(initHero);
    r.querySelectorAll('[data-ink-reveal]').forEach(initReveal);
    r.querySelectorAll('[data-ink-cats]').forEach(initCats);
    r.querySelectorAll('[data-ink-brands]').forEach(initBrands);
    initSqueegee(r);
    initBoosterEnhance();
    initYt(r);
  }
  boot();
  // theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Merged brand filter (snippets/ink-filter-values): one visible checkbox stands for several Acumatica vendors that share
   a display name (e.g. SPSI - Velox). Keep its hidden partners in step BEFORE the filter form's own change handler
   rebuilds the URL (capture phase), and make the matching active chip clear every vendor behind the name. */
(function () {
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches || !t.matches('[data-ink-fgroup]')) return;
    var lab = t.closest('label'); if (!lab) return;
    [].forEach.call(lab.querySelectorAll('[data-ink-fmirror]'), function (m) { m.checked = t.checked; });
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-ink-fclear]'); if (!a) return;
    var p = a.getAttribute('data-ink-fclear'), vals = (a.getAttribute('data-vals') || '').split('||').filter(Boolean);
    if (vals.length < 2) return; // a single vendor: Shopify's own remove link is right
    e.preventDefault();
    var u = new URL(window.location.href), keep = u.searchParams.getAll(p).filter(function (v) { return vals.indexOf(v) < 0; });
    u.searchParams.delete(p); keep.forEach(function (v) { u.searchParams.append(p, v); }); u.searchParams.delete('page');
    window.location.assign(u.toString());
  });
})();

/* Shopify Forms dropdowns (service request on Support, Contact): pressing the open list's scrollbar closed the list, so
   it could not be dragged (2026-10-20). A press on the list box itself (the scrollbar, never an option) is kept from
   the widget's handlers; options, the wheel and the native scrollbar drag work as before. */
(function () {
  ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      var p = e.composedPath && e.composedPath()[0];
      if (p && p.classList && /(^| )_optionList_/.test(p.className)) e.stopPropagation();
    }, true);
  });
})();
